import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { Home, ArrowLeft } from 'lucide-react'

export default function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <h1 className="font-display text-8xl font-bold text-primary/20 mb-4">404</h1>
        <h2 className="text-2xl font-bold mb-2">{t('notFound.title')}</h2>
        <p className="text-muted-foreground mb-6">{t('notFound.description')}</p>
        <div className="flex items-center justify-center gap-3">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-secondary text-sm font-medium hover:bg-secondary/80 transition-colors">
            <ArrowLeft className="w-4 h-4" /> {t('notFound.goBack')}
          </button>
          <Link to="/" className="flex items-center gap-2 px-4 py-2 rounded-lg bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors">
            <Home className="w-4 h-4" /> {t('notFound.goHome')}
          </Link>
        </div>
      </div>
    </div>
  )
}
